module.exports = {"label":{"generated_at":"Bericht erstellt"}}